module.exports = __webpack_public_path__ + "static/media/branded-order-mobile-view.00b262ea.png";